module.exports = (__webpack_require__(2))("./core/header.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/header.js from dll-reference base
// module id = 97
// module chunks = 22